import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { Route, Router } from 'react-router-dom'
import environment from 'shared/environment'
import { QueryParamProvider } from 'use-query-params'

import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'

import { WithLooopThemeContext } from '../public-api/hooks/useLooopTheme'
import { appHistory } from '../app/util/appHistory'
import { CheckUsersTimezone } from '../utils/checkUsersTimezone'
import ErrorBoundary from './common/error/ErrorBoundary'
import ModalService from './common/modal/ModalService'
import Notifications from './common/notifications/Notifications'
import { LooopRouters } from './LooopRouters'
import UpdatePopup from './utils/update-popup/UpdatePopup'
import IEWarningPopup from './utils/ie-warning-popup/IEWarningPopup'
import Loader from './common/loader/Loader'
import { getRootLooopAppDOMElement } from 'front-end/src/components/utils/rootElResolver'

import '../less/styles.less'
import { WithPublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

const AppRoot = ({ routes: AppRoutes }) => {
  return (
    <WithLooopThemeContext>
      <I18nProvider i18n={i18n} forceRenderOnLocaleChange={false}>
        <Suspense fallback={<Loader />}>
          <WithPublicApiSession>
            <Router history={appHistory}>
              <QueryParamProvider ReactRouterRoute={Route}>
                <ErrorBoundary>
                  <IEWarningPopup />
                  <UpdatePopup />
                  <AppRoutes />
                  <ModalService />
                  <CheckUsersTimezone />
                  <Notifications />
                </ErrorBoundary>
              </QueryParamProvider>
            </Router>
          </WithPublicApiSession>
        </Suspense>
      </I18nProvider>
    </WithLooopThemeContext>
  )
}

export const renderLooopApp = (routes = LooopRouters) => {
  // TODO: Move that GA identifier to .env
  if (environment.isProduction()) {
    ReactGA.initialize('UA-49981349-2')
  } else {
    ReactGA.initialize('UA-49981349-2', {
      useExistingGa: true
      // debug: true // For detailed debugging purposes
    })
  }
  ReactGA.set({ hostname: window.location.hostname })
  ReactDOM.render(<AppRoot routes={routes} />, getRootLooopAppDOMElement())
}
